import React from 'react';
import '../StyleSheets/FilterSelect.css';

import MaterialIcon from 'material-icons-react';


export default class FilterSelect extends React.Component {

    constructor(props) {
        super(props)

        let allActive = props.list.length === props.activeItems.length;
        props.activeItems.forEach( _ => allActive = _ );

        this.state= {
            activeItems: props.activeItems,
            listOpen: false,
            allSelected: allActive,
        }
    }

    onItemClick( inx ) {

        const { activeItems } = this.state;

        if( activeItems[ inx ] !== undefined ) {
            activeItems[ inx ] = !activeItems[ inx ];
        } else {
            activeItems[ inx ] = true;
        }

        this.setState({activeItems: activeItems}, () => this.props.onItemSelect( activeItems ) );

    }

    render() {
        const { list, theme, title, bgColor, onItemSelect } = this.props;
        const { listOpen, allSelected, activeItems } = this.state;
        //list: [{key,title}]
        //theme: "light" / "dark"

        let color = "#000000";

        switch( theme ) {
            case "light" : color = "#ffffff"; break;
            case "dark" :  color = "#000000"; break;
            default: color ="#aaaaaa"; break;
        }

        const style = {
            top: this.props.position.t,
            right: this.props.position.r,
            color: color
        }

        return (
        
            <div className="filterSelect" style={style}>
                <div className="titleBox" onClick={()=>this.setState( {listOpen: !listOpen})}>
                    <div id="filterSelectIconCont">
                        <MaterialIcon icon="filter_list" size = {18} color={ color }/>
                    </div>
                    <div>{title}</div>
                </div>
                { listOpen ? <div className="filterListBox" 
                                style={{backgroundColor: bgColor}}
                                onMouseLeave={()=>this.setState( {listOpen:false}) }
                            >
                                <FilterButton 
                                    tooltipTitle="בחירת כל האפשרויות" 
                                    iconName="check_box"
                                    displayName=""
                                    isActive={allSelected}
                                    color={color}
                                    onClick={()=> {
                                        const newActiveItems = activeItems.map( item=> item = !allSelected );
                                        this.setState({allSelected: !allSelected, activeItems: newActiveItems}
                                            );
                                            onItemSelect(newActiveItems);
                                    } }
                                />
                                {list.map( (item,i) => {
                                    return (
                                        <div 
                                            key={item.key+i} 
                                            className="filterItem"
                                            style={{opacity: activeItems[i] ? 1 : 0.3 }} 
                                            onClick={()=>this.onItemClick(i)}
                                        >
                                            {item.title}
                                        </div>
                                    );
                                })}
                    </div>
                : null }
            </div>
        )
        
    }

}

function FilterButton(props) {

    const { iconName, tooltipTitle, displayName, isActive, onClick, color } = props;

    return (
        <div className="filterInnerButton" title={tooltipTitle}
            style={{
                opacity: isActive ? 1 : 0.3, 
            }}
            onClick={onClick}>
            <MaterialIcon icon={iconName} size = {24} color={ color }/>
            <span style={{paddingRight: displayName !== "" ? "4px" : "0px"}}>{displayName}</span>
        </div>
    )
}